export default __webpack_public_path__ + "media/images/dashboard_icons/clipboard-2a0a3d8470584748fc21dfa507794c9d.svg";